import React, { useEffect, useState } from 'react';
import InputComponent from '../inputcomponents/InputComponent';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { adminLogin, userLogin, logout } from '../../feature/user/roleSlice';
import { login } from '../../feature/user/userSlice';
import { userSlice } from '../../feature/user/userSlice';

const Login = () => {
  const loggedInUser = useSelector((state) => state.user.user);
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState({
    email: '',
    password: '',
  });
  const { email, password } = user;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({
    email: '',
    password: '',
  });

  const handleChange = (name, value) => {
    setUser({ ...user, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };
  const Validation = (user) => {
    let validationErrors = {};

    if (!user?.email.trim()) {
      validationErrors.email = '* Email is Required';
    }

    if (!user?.password.trim()) {
      validationErrors.password = '* Password is Required';
    }
    setErrors({ ...errors, ...validationErrors });
  };
  const handleLogin = (e) => {
    e.preventDefault();
    if (!Validation(user)) {
      setIsLoading(true);
      dispatch(login(user))
        .then((action) => {
          if (
            action.payload.error_message ===
            'This email does not exist in our records'
          ) {
            setErrors({ ...errors, email: action.payload.error_message });
            setIsLoading(false);
          } else if (
            action.payload.error_message ===
            'The provided credentials are incorrect.'
          ) {
            setErrors({
              ...errors,
              password: 'You Have Entered Incorrect Password',
            });
            setIsLoading(false);
          } else {
            const { role } = action?.payload;
            const landingPage = role.landingpage;
            setIsLoading(false);
            navigate(`/${landingPage}`);
          }
        })
        .catch((error) => {
          console.error(error, 'error here');
          setIsLoading(false);
        });
    }
  };

  const [role, setRole] = useState({});
  useEffect(() => {
    localStorage.removeItem('persist:user');
    sessionStorage.removeItem('persist:user');
    sessionStorage.clear();
    localStorage.clear();
  }, []);
  return (
    <div className='login-page'>
      <div className='card login-card'>
        <h2 className='login-headline'>Viro LIMS</h2>
        <p>
          <span className='login-sign-in-text-bold'>Sign in</span> <br />
          to continue to VLIMS
        </p>
        <form className='form login-form' onSubmit={handleLogin}>
          <div>
            <InputComponent
              type={'email'}
              name={'email'}
              value={email}
              placeholder={'Enter Email'}
              handleChange={handleChange}
            />
            {errors.email && (
              <span className='error-message text-danger ms-1'>
                {errors.email}
              </span>
            )}
          </div>
          <div>
            <InputComponent
              type={'password'}
              name={'password'}
              value={password}
              placeholder={'Enter Password'}
              handleChange={handleChange}
            />
            {errors.password && (
              <span className='error-message text-danger ms-1'>
                {errors.password}
              </span>
            )}
          </div>
          <div className='login-btn-wrapper'>
            {isLoading ? (
              <button
                className='btn  btn-lg login-btn btn-disabled'
                type='submit'
                disabled
              >
                Logging in ...
              </button>
            ) : (
              <button className='btn  btn-lg login-btn' type='submit'>
                Login
              </button>
            )}
          </div>
        </form>
        {/* <div className='text-center '>
          <div className='divider-container'>
            <span>OR</span>
          </div>
          <Link to={'/signup'} className='login-to-signup-text'>
            Create an Account
          </Link>
        </div> */}
      </div>
    </div>
  );
};

export default Login;
